export default __webpack_public_path__ + "static/media/learn-icon-sidebar.f837eca6.png";